import { Can } from "@casl/react";
import { useSelector } from "@tanstack/react-store";
import type { FC } from "react";

import type { AppAbility } from "@recobra/core";
import { m } from "@recobra/i18n/messages";
import { calculateTaskDeadline } from "@recobra/schemas/task";
import { FieldGroup } from "@recobra/ui/field";

import { useTaskTypes } from "../task-data";
import { formatTaskDate } from "../task-display";
import { TaskSummaryList, TaskSummaryRow } from "../task-display";
import { TaskAssigneeSection } from "./TaskAssigneeSection";
import type { TaskCreationFormApi } from "./useTaskCreationForm";

/** The end deadline the task will get once assigned, and who it is assigned to. */
export const TaskSchedulingSection: FC<{
  form: TaskCreationFormApi;
  isOpen: boolean;
  contextType: "case" | "client";
  contextId: string;
}> = ({ form, isOpen, contextType, contextId }) => {
  const selectedTaskType = useSelector(form.store, (state) => state.values.taskType);
  const assignedTo = useSelector(form.store, (state) => state.values.assignedTo);
  const selectedSettings = useTaskTypes().data?.get(selectedTaskType);
  const deadlineDate =
    assignedTo && selectedSettings
      ? calculateTaskDeadline(new Date().toISOString(), selectedSettings.slaBusinessDays)
      : undefined;

  return (
    <FieldGroup>
      <TaskSummaryList>
        <TaskSummaryRow label={m.task_field_deadline()}>
          {deadlineDate ? formatTaskDate(deadlineDate) : m.common_em_dash()}
        </TaskSummaryRow>
        <Can<AppAbility> do="assignOnCreate" on="Task">
          <TaskAssigneeSection
            form={form}
            isOpen={isOpen}
            contextId={contextId}
            contextType={contextType}
          />
        </Can>
      </TaskSummaryList>
    </FieldGroup>
  );
};
